import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AlertTriangle, ArrowRight } from "lucide-react";

export default function MissingDataAlert() {
  const { isAdmin } = useAuth();
  const [rows, setRows] = useState(null);
  const [all, setAll] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (!isAdmin) return;
    api.get("/bookings-missing-data").then((r) => setRows(r.data.rows)).catch(() => {});
  }, [isAdmin]);
  if (!rows?.length) return null;
  const shown = all ? rows : rows.slice(0, 5);
  return (
    <div className="rounded-lg border border-rose-200 bg-rose-50/70 p-4 mb-6" data-testid="missing-data-alert">
      <div className="flex items-center gap-2 text-sm font-semibold text-rose-800 mb-2">
        <AlertTriangle size={16} /> {rows.length} prenotazioni senza dati importanti <span className="font-normal text-rose-600 text-xs">· totale € (da oggi in poi) · orari speedboat e volo (prossimi 7 giorni)</span>
      </div>
      <ul className="divide-y divide-rose-100">
        {shown.map((b) => (
          <li key={b.id} className="flex flex-wrap items-center gap-x-3 gap-y-1 py-1.5 text-sm" data-testid={`missing-row-${b.id}`}>
            <span className="font-medium text-slate-800">{b.guest_surname} {b.guest_name}</span>
            <span className="text-slate-500 text-xs">{b.checkin} → {b.checkout} · {b.room || "camera non trovata"} · {b.status}</span>
            <span className="text-xs font-semibold text-rose-700">manca: {b.missing.join(", ")}</span>
            <button data-testid={`missing-open-${b.id}`} onClick={() => navigate(`/money?edit=${b.id}`)} className="ml-auto text-xs font-semibold text-rose-700 hover:text-rose-900 inline-flex items-center gap-1 py-2 md:py-0">Completa <ArrowRight size={13} /></button>
          </li>
        ))}
      </ul>
      {rows.length > 5 && (
        <button data-testid="missing-toggle-all" onClick={() => setAll(!all)} className="mt-1 py-2 md:py-0 text-xs font-semibold text-rose-700 hover:underline">
          {all ? "Mostra meno" : `Mostra tutte (${rows.length})`}
        </button>
      )}
    </div>
  );
}
